import { render } from "./perPortraitPerson.vue?vue&type=template&id=939c31e6&scoped=true"
import script from "./perPortraitPerson.vue?vue&type=script&lang=js"
export * from "./perPortraitPerson.vue?vue&type=script&lang=js"

import "./perPortraitPerson.vue?vue&type=style&index=0&id=939c31e6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-939c31e6"]])

export default __exports__